import { render } from "./index.vue?vue&type=template&id=5ce67a16"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/design/components/molecules/news-and-seminar-radio/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5ce67a16"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5ce67a16', __exports__)) {
    api.reload('5ce67a16', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=5ce67a16", () => {
    api.rerender('5ce67a16', render)
  })

}


export default __exports__